import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleSizes, CircleVariants, } from "../../../Molecules/Loading/Circle/constants";
import { Contrast } from "../../../types/general.types";
import { LabelVariants, LabelWeights, } from "../../../Atoms/Text/Label/constants";
import { MainVariants } from "./constants";
import { StyledButton, StyledLoading } from "./Main.style";
import { useEffect, useState } from "react";
import Circle from "../../Loading/Circle/Circle";
import { Icon } from "../..";
import { IconVariants } from "../../Images/Icon/constants";
import { Label } from "../../../Atoms";
import useWindowSize from "../../../../hooks/layout/useWindowSize";
const Main = ({ onClick = () => { }, onMouseOver = () => { }, onMouseLeave = () => { }, isDisabled = false, isLoading = false, variant = MainVariants.primary, contrast = Contrast.default, text = "", iconName = "", fillContainer = false, paddingSize = "default", ...props }) => {
    const { width } = useWindowSize();
    const [isMobile, setIsMobile] = useState(true);
    useEffect(() => {
        const isMobile = width <= 320;
        setIsMobile(isMobile);
    }, [width]);
    const getLabelProps = (variant, isDisabled, contrast) => {
        const labelProps = {
            weight: LabelWeights.bold,
        };
        if (isDisabled)
            return { labelProps, isDisabled: true, variant: LabelVariants.neutral };
        switch (variant) {
            case MainVariants.primary: {
                if (contrast === Contrast.dark)
                    return {
                        ...labelProps,
                        variant: LabelVariants.primary,
                        contrast: Contrast.default,
                    };
                if (contrast === Contrast.light)
                    return {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.light,
                    };
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    contrast: Contrast.dark,
                };
            }
            case MainVariants.secondary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.secondary,
                    contrast: contrast,
                };
            }
        }
    };
    const getIconProps = (variant, isDisabled, contrast) => {
        if (isDisabled)
            return { isDisabled: true };
        switch (variant) {
            case MainVariants.primary: {
                if (contrast === Contrast.dark)
                    return { variant: IconVariants.primary };
                if (contrast === Contrast.light)
                    return { contrast: Contrast.light };
                return { contrast: Contrast.dark };
            }
            case MainVariants.secondary: {
                return { variant: IconVariants.secondary, contrast: contrast };
            }
        }
    };
    const getCircleProps = (variant, contrast) => {
        switch (variant) {
            case MainVariants.primary: {
                return {
                    contrast: contrast === Contrast.light ? Contrast.light : Contrast.dark,
                };
            }
            case MainVariants.secondary: {
                return { variant: CircleVariants.secondary, contrast: contrast };
            }
        }
    };
    return (_jsxs(StyledButton, { onClick: isDisabled ? () => { } : onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, isDisabled: isDisabled, disabled: isDisabled, isMobile: isMobile, variant: variant, contrast: contrast, fillContainer: fillContainer, justifyBetween: fillContainer && !!iconName && (!isLoading || isDisabled), paddingSize: paddingSize, ...props, children: [(!isLoading || isDisabled) && text && (_jsx(Label, { ...getLabelProps(variant, isDisabled, contrast), children: text })), (!isLoading || isDisabled) && iconName && (_jsx(Icon, { name: iconName, ...getIconProps(variant, isDisabled, contrast) })), isLoading && !isDisabled && (_jsxs(StyledLoading, { children: [_jsx(Label, { ...getLabelProps(variant, isDisabled, contrast), children: text }), _jsx(Circle, { active: isLoading, size: CircleSizes.small, ...getCircleProps(variant, contrast) })] }))] }));
};
export default Main;
//# sourceMappingURL=Main.js.map